import {Container} from "../core/Container";
import {Callback} from "../core/Reflection";
import {Poly} from "../core/Shape";
import {AnimationContext} from "./animations/AnimationContext";
import {Optionable} from "./Optionable";
import {SceneItem} from "./SceneItem";

export class SceneItemMask extends Container implements Optionable {

    public readonly maskOf?: string;
    public readonly maskPoints: number[] = [];
    private maskPoly?: Poly;

    public getVisible(): boolean {
        return this.visible;
    }

    public setVisible(value: boolean): void {
        this.visible = value;
    }

    public animate(context: AnimationContext, cb: Callback): void {
        const targets = context.scene.collectFromItems((it, items: SceneItem[]) => {
            if (it instanceof SceneItem && it.animationObj && it.animationObj.id === this.maskOf) {
                items.push(it);
            }
        });
        for (const target of targets) {
            if (!this.maskPoly) {
                this.maskPoly = this.addChild(new Poly(this.maskPoints));
            }
            target.mask = this.maskPoly;
            for (const paperCut of target.getAllPaperCuts()) {
                paperCut.mask = this.maskPoly;
            }
        }
        cb();
    }
}
